import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

const InviteFriends = ({ inviteFriends }) => {
  return (
    <div className='four columns'>
      <h1 className='header'>{I18n.t('layouts.footer.invite')} </h1>
      <ul className='inner'>
        <li>
          <a href={inviteFriends.invite_path}>
            <img
              className='dotip fastretina hoot lazyload invite-friends-apprentus-logo'
              width='111'
              height='119'
              data-src={inviteFriends.img_url}
              data-retina={inviteFriends.img_url_retina}
              alt=''
              title='Hoot'
            />
          </a>
          <div className='invite-friends-info'>
            <a
              href={inviteFriends.invite_path}
              ref={el => {
                if (el) {
                  el.style.setProperty('color', '#222', 'important')
                }
              }}
            >
              <strong id='footer_invite_header'>{I18n.t('layouts.footer.invite')}</strong>
            </a>
            <br />
            <br />
            {I18n.t('layouts.footer.invite_extra', { invite_bonus_sum: inviteFriends.invite_bonus_sum })}
          </div>
        </li>
      </ul>
    </div>
  )
}

InviteFriends.propTypes = {
  inviteFriends: PropTypes.object
}

export default InviteFriends
